import {Component,Input,ElementRef, ViewChild,ChangeDetectorRef,Output, EventEmitter} from '@angular/core';

import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
//import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';
import { SharedService } from '../../services/shared.service';
import { LoaderService } from '../../services/Spinner.service';
import { LocalStorage } from '../../services/local-storage';
import { PopupLogoutComponent } from '../../users/popup/popup-logout.component';
import { Campaign } from '../../models/compaign';
export interface ConfirmModel {
  title:string;
  message:string;
}

@Component({  
    selector: 'image-croper',
    templateUrl: './profileimageCroper.component.html',
    providers: [SharedService,PopupLogoutComponent]
})
export class profileimageCroperComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  @Output() imageUpdated = new EventEmitter();
 // imageUpdated: EventEmitter<any> = new EventEmitter;
  campaign=new Campaign();
  title: string;
  message: string;
  //cropperSettings1: CropperSettings;
  croppedWidth: number=300;
  croppedHeight: number=300;
  imageData: any = [];
  imageDta: any;
  data1: any;
  imageUrl:any;
     blob:any;
  imageloaderFlag:boolean=false;
  imageFlag:boolean=true;
  user:string="dsfsdf";
  //@ViewChild('imgBox') imgBox;
  //@ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  constructor(dialogService: DialogService,private localstorage:LocalStorage,private shareService: SharedService,private loaderService: LoaderService) {
    super(dialogService);
     
   // this.imageCropper();
  } 

//   imageCropper() {
//         this.cropperSettings1 = new CropperSettings();
//         this.cropperSettings1.width = this.croppedWidth;
//         this.cropperSettings1.height = this.croppedHeight;

//         this.cropperSettings1.croppedWidth = 100;
//         this.cropperSettings1.croppedHeight = 100;

//         this.cropperSettings1.canvasWidth = this.croppedWidth;
//         this.cropperSettings1.canvasHeight = this.croppedHeight;

//         this.cropperSettings1.minWidth = 100;
//         this.cropperSettings1.minHeight = 100;

        

//         this.cropperSettings1.rounded = false;
//         this.cropperSettings1.keepAspect = true;

//         this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
//         this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;
//         this.cropperSettings1.minWithRelativeToResolution=false;
        

//         this.data1 = {};
//     }
//      cropped(bounds: Bounds) {
//         var imageDta = this.data1.image;
//         let type = imageDta.split(';')[0].split(':')[1];

//         var extention = type.split("/")[1];
//         //let type = this.imageDta.split(';')[0].split(':')[1];
//         //let extension=type.splif("/")[1];
//         this.urltoFile(imageDta, 'croped.' + extention, type).then((result) => {
//             this.imageData[0] = result;


//         });
// var b64 = this.data1.image.split(',');


//      this.blob = this.b64toBlobNew(b64[1],type);

//     }

b64toBlobNew(b64Data,contentType){
      var byteCharacters = atob(b64Data);
      var byteNumbers = new Array(byteCharacters.length);
for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
}

var byteArray = new Uint8Array(byteNumbers);
var blob = new Blob([byteArray], {type: contentType});
return blob;
  }
    // fileChangeListener($event) {
    //     this.imageFlag=false;
    //     this.imageDta = $event.target.files;

    //     var image: any = new Image();
    //     var file: File = $event.target.files[0];
    //     var myReader: FileReader = new FileReader();
    //     var that = this;
    //     document.getElementsByTagName("canvas")[0].style.display = "block";
    //     myReader.onloadend = (loadEvent: any) => {
    //         // image.src = loadEvent.target.result;
    //         var imageDta = loadEvent.target.result;
    //         let type = imageDta.split(';')[0].split(':')[1];


    //         var extention = type.split("/")[1];
    //         //let type = this.imageDta.split(';')[0].split(':')[1];
    //         //let extension=type.splif("/")[1];
    //         this.urltoFile(imageDta, 'croped.' + extention, type).then((result) => {
    //             this.imageDta[0] = result;

    //         });

    //         //  that.cropper.setImage(image);
    //     };
    //     var t = myReader.readAsDataURL(file);

    // }
    // urltoFile(url, filename, mimeType) {
    //     return (fetch(url)
    //         .then(function (res) {
    //             return res.arrayBuffer();
    //         })
    //         .then(function (buf) {
    //             return new File([buf], filename, {
    //                 type: mimeType
    //             });
    //         })
    //     );
    // }
    // getImageUrl(imageUrl) {
    //     console.log("getImageUrl");
        
    //     var arg={imageurl:"hello"};
    //     console.log(arg);
    //     let isValid = this.imageUpdated.emit(arg) || true;
    //     if (isValid) {
    //         console.log("emit value");
    //         // Do stuff
    //     } else {
    //         console.log("not emit value");
    //     }
    // }
    // onChangeImage(){
    //     console.log("on change url");
    //     console.log(this.imageUpdated);
    //    return this.imageUpdated;
    // }
    // uploadImage() {
    //     this.imageloaderFlag = true;
    //     let fileList: FileList = this.imageData;
    //     console.log(this.imageData);
    //     let file: File = fileList[0];
    //     let formData: FormData = new FormData();
    //     console.log(formData);
    //     formData.append('profilePic', this.blob);
    //     var token = this.localstorage.getStorage("token");
    //     this.loaderService.displayLoader(true);
    //      this.shareService.uploadImage("adv/profile/uploadImage", formData, token).subscribe((result) => {
    //         if (result.data) {
    //             console.log(result.data);
    //             (<HTMLInputElement>document.getElementById('profileImage')).src = result.data.profileUrl;
    //             // for(var j=0; j<5;j++) {
    //             //     var pView=document.getElementsByClassName("campaignImage")[j];
    //             //     pView.setAttribute("src",result.data.imgUrl);
    //             // }
    //             //this.getImageUrl(result.data.imgUrl);
    //             this.cancel();
    //             //this.createObj.setImagurl(result.data.imgUrl);
    //             this.imageUrl=result.data.imgUrl;
    //                 this.campaign.campaignImage = result.data.imgUrl;

               
    //             setTimeout(() => {
    //                 this.imageloaderFlag = false;
    //             }, 3000);

    //         } else {
    //             this.campaign.loaderFlag = false;
    //          }
    //         this.loaderService.displayLoader(false);
    //     });
    // }
    // checkimageURL(url) {
    //     if (url) {
    //         return (url.match(/\.(jpeg|jpg|JPG|gif|png)$/) != null);
    //     }

    // }
  confirm() {
    this.result = true;
    this.close();
  }
  cancel() {
    this.result = false;
    this.close();
  }

cropImage(img) {
      console.log(img);
      this.imageloaderFlag=true;
      let type = img.imgCrop.split(';')[0].split(':')[1];
      var extention = type.split("/")[1];
      var b64 = img.imgCrop.split(',');
      this.blob = this.b64toBlobNew(b64[1],type);
      let formData: FormData = new FormData();
        console.log(formData);
        formData.append('banner',this.blob);
        console.log(formData);
        formData.append('profilePic', this.blob);
        var token = this.localstorage.getStorage("token");
        this.loaderService.displayLoader(true);
         this.shareService.uploadImage("adv/profile/uploadImage", formData, token).subscribe((result) => {
            if (result.data) {
                console.log(result.data);
                (<HTMLInputElement>document.getElementById('profileImage')).src = result.data.profileUrl;
                // for(var j=0; j<5;j++) {
                //     var pView=document.getElementsByClassName("campaignImage")[j];
                //     pView.setAttribute("src",result.data.imgUrl);
                // }
                //this.getImageUrl(result.data.imgUrl);
                
                //this.createObj.setImagurl(result.data.imgUrl);
                this.imageUrl=result.data.imgUrl;
                this.campaign.campaignImage = result.data.imgUrl;

               setTimeout(() => {
                    this.imageloaderFlag = false;
                    this.loaderService.displayLoader(false);
                    this.cancel();
                }, 3000);
                

            } else {
                this.campaign.loaderFlag = false;
                this.loaderService.displayLoader(false);
             }
            
        });

  }

  
}



// WEBPACK FOOTER //
// ./src/app/advertiser/popup/profileimageCroper.component.ts